export const version = '3.7.0';
export const commit = '278598a2';
